import { userPlaceholder } from 'assets/icons';
import NotFound from 'common/NotFound';
import useDebounce from 'common/UseDebounce';
import useFullPageLoader from 'common/UseFullPageLoader';
import { SearchBar } from 'components/form';
import { CustomModal } from 'components/modals/ModalBox'
import React, { useEffect, useState } from 'react'
import { GiMedicines } from 'react-icons/gi';
import Pagination from 'react-js-pagination';
import { useSearchParams } from 'react-router-dom';
import { medicineListApi } from 'services/user';
import findSerialNumber from 'utils/findSerialNumber';
import { toastMessage } from 'utils/toastMessage';
import MedicineType from './MedicineType';

const AddMedicines = ({ show, close, userId, listing = () => { } }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [loader, onShow, onHide] = useFullPageLoader();
    const [productList, setProductList] = useState([])
    const activePage = +searchParams.get("page") || 1;
    const limit = +searchParams.get("limit") || 10;
    const [total, setTotal] = useState(0)
    const search = searchParams.get("search") || "";
    const debouncedValue = useDebounce(search, 300);
    const [imagePreview, setImagePreview] = useState({ url: '', modal: false });
    const [medicineTypeModal, setMedicineTypeModal] = useState({ modal: false })
    // console.log('medicineTypeModal', medicineTypeModal)
    // console.log('productList', productList)
    // ----------search------------
    const setSearchFun = (searchTxt) => {
        const newParams = new URLSearchParams(searchParams); // safe copy
        newParams.set("page", 1);
        newParams.set("search", searchTxt);
        setSearchParams(newParams);
    };
    //-----------Handel-Pagination----------- 
    const handlePageChange = (event) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("page", event);
        setSearchParams(newParams);
    };
    //-------------image-preview-------------
    const handleImagePrev = (url) => {
        if (url) {
            setImagePreview({ url: url, modal: true })
        }
    };
    // ----------Listing-API-------------------
    const fetchMedicineList = async () => {
        const query = {
            search: debouncedValue || '',
            page: activePage,
            limit: limit,
        };
        onShow();
        try {
            const res = await medicineListApi(userId, query);
            const { code, data } = res?.data;
            if (code === 200) {
                setTotal(data?.total || 0)
                setProductList(data?.data || []);
            }
        } catch (error) {
            console.log(error);
        } finally {
            onHide();
        }
    };
    // -------close-modal----------------
    const closeModal = () => {
        close()
        setMedicineTypeModal(false)
        searchParams.delete('page')
        setSearchParams(searchParams)
    }
    useEffect(() => {
        if (show) {
            fetchMedicineList();
        }
    }, [activePage, show, debouncedValue]);
    const handleAddToCart = (product) => {
        const defaultVariant =
            product?.variant?.find((variant) => variant?.billOnlyInStrip) ||
            product?.variant?.[0];

        if (!defaultVariant?._id) {
            return toastMessage("Variant not available", "error");
        }

        setMedicineTypeModal({
            modal: true,
            productId: product?._id,
            variantId: defaultVariant?._id,
            userId,
            billOnlyInStrip: defaultVariant?.billOnlyInStrip,
        });
    };


    useEffect(() => {
        if (!debouncedValue) {
            searchParams.delete('search')
        }
        if (activePage === 1) {
            searchParams.delete('page')
        }
        setSearchParams(searchParams)
    }, [debouncedValue, activePage])
    return (
        <>
            <CustomModal
                className={"add_model"}
                show={show}
                handleClose={closeModal}
                size='xl'//lg xl
            >
                <div className="user-management-container">
                    <div className="page_title has_child">
                        <h3>Medicines List</h3>
                    </div>
                    <div className="search_wrapper-option-selector">
                        <SearchBar
                            onKeyDown={(e) => {
                                const allowedKeysRegex = /^[a-zA-Z0-9\- ]$/;
                                const controlKeys = [
                                    "Backspace",
                                    "ArrowLeft",
                                    "ArrowRight",
                                    "Delete",
                                    "Tab",
                                    "Escape",
                                ];

                                // Allow letters, numbers, space, hyphen
                                if (allowedKeysRegex.test(e.key) || controlKeys.includes(e.key)) {
                                    return;
                                }

                                // Block everything else
                                e.preventDefault();
                            }}
                            placeholder={"Search..."}
                            onChange={(e) => setSearchFun(e.target.value)}
                            value={search}
                        />

                    </div>
                    {/* ---------card */}
                    <div className="card">
                        {loader}
                        <div className="table-container">
                            <table className="table custom_table">
                                <thead>
                                    <tr>
                                        <th className="nowrap text-center">S.No</th>
                                    <th className="nowrap text-center">ProductId</th>

                                        <th className="nowrap text-center">Image</th>
                                        <th className="nowrap text-center">Name </th>
                                        <th className="nowrap text-center">Type </th>
                                        <th className="nowrap text-center">Description</th>
                                        {/* <th className="nowrap text-center">Variant</th> */}
                                        <th className="nowrap text-center">MRP</th>
                                        <th className="nowrap text-center">Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {productList.length > 0 ? (
                                        productList?.map((data, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className="nowrap text-center">
                                                        {findSerialNumber(index, activePage, limit)}
                                                    </td>
                                                      <td className="nowrap text-center">
                                                        {data?.productId}
                                                    </td>

                                                    <td className="nowrap text-center">
                                                        <div className="td-img ">
                                                            <img
                                                                src={data?.image?.[0] || userPlaceholder}
                                                                alt={data?.fullName}
                                                                onClick={() => handleImagePrev(data?.image?.[0])}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td className="nowrap text-center">
                                                        {data?.name || "N/A"}
                                                    </td>
                                                    <td className="nowrap text-center">
                                                        {data?.type || "N/A"}
                                                    </td>
                                                    <td className="nowrap text-center">
                                                        {data?.description
                                                            ? data.description.replace(/<[^>]+>/g, '').slice(0, 30) +
                                                            (data.description.length > 25 ? '...' : '')
                                                            : "N/A"}
                                                    </td>

                                                    {/* <td className="nowrap text-center">
                                                        {data?.variant?.map((item, idx) => (
                                                            <div key={idx}>
                                                                {item?.unitValue} - {item?.unit} ({item?.quantity})
                                                            </div>
                                                        ))}
                                                    </td> */}

                                                    <td className="nowrap text-center">
                                                        {data?.variant?.length > 0
                                                            ? data?.variant.map((item, idx) => (
                                                                <div key={idx}>
                                                                    ₹{item?.mrp || "N/A"}
                                                                </div>
                                                            ))
                                                            : "N/A"}
                                                    </td>
                                        
                                                    <td className="nowrap text-center">
                                                        <div className="button-container">
                                                            <button
                                                                type="button"
                                                                className="button"
                                                                onClick={() =>
                                                                    handleAddToCart(data)
                                                                }
                                                            >
                                                                Add Cart
                                                            </button>
                                                        </div>
                                                    </td>

                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <NotFound
                                            cols={9}
                                            msg={"Medicines data not found"}
                                            onHide={onHide}
                                            icon={<GiMedicines />}
                                        />
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* ---------preview-image--------------- */}
                    <CustomModal
                        className={"sm image_preview_modal"}
                        show={imagePreview?.modal}
                        handleClose={() => { setImagePreview({ url: '', modal: false }) }}
                    >
                        <div className="image_preview">
                            <img
                                src={imagePreview?.url || userPlaceholder}
                                alt="user-profile-preview"
                            />
                        </div>
                    </CustomModal>
                    {/* ------pagination-----------*/}
                    {total > limit && (
                        <div className="pagination-wrapper">
                            <div className="Pagination">
                                <Pagination
                                    activePage={activePage}
                                    previousLabel={"previous"}
                                    nextLabel={"next"}
                                    itemsCountPerPage={limit}
                                    totalItemsCount={total}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange}
                                    hideDisabled={true}
                                />
                            </div>
                        </div>
                    )}
                </div>



            </CustomModal>

            {/* ---------medicine-type-modal--------------------- */}
            <MedicineType
                show={medicineTypeModal?.modal}
                close={() => { setMedicineTypeModal({ modal: false }) }}
                data={medicineTypeModal}
                listing={listing}
                fetchMedicineList={fetchMedicineList}
            />
        </>
    )
}

export default AddMedicines
